import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { offerIncludes } from '../data/strategy';
export function OfferSection() {
  return <section id="acceso" className="border-b border-line" data-id="element-42" data-mp="3m96poi3qqeg">
      <div className="mx-auto w-full max-w-[1400px] px-5 py-16 sm:px-6 lg:px-10 lg:py-28" data-id="element-43" data-mp="8mdoriynrt6s">
        <div className="mx-auto max-w-4xl overflow-hidden rounded-lg border border-white/10 bg-ink-800" data-id="element-44" data-mp="deewcrkvsvqh">
          <div className="grid md:grid-cols-5" data-id="element-45" data-mp="ic6p1ntcolvq">
            <div className="border-b border-line p-6 sm:p-8 md:col-span-3 md:border-b-0 md:border-r md:p-10" data-id="element-46" data-mp="ifkr0uy3qt2n">
              <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-cyan-vip sm:text-[11px]" data-id="element-47" data-mp="rdwptk94gx66">
                Acceso VIP
              </span>
              <h2 className="mt-4 text-[22px] font-semibold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-48" data-mp="wchhgvab68j0">
                Manual Protocolo de Apertura VIP
              </h2>
              <p className="mt-3 text-[14px] leading-relaxed text-white/50" data-id="element-49" data-mp="2y5fhpc6f03dz">
                Todo el sistema documentado paso a paso, con las herramientas
                para ejecutarlo desde la primera sesión.
              </p>

              <ul className="mt-6 space-y-3 sm:mt-8" data-id="element-50" data-mp="xup6wt0ecvfa">
                {offerIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-51" data-mp="svmdy6xoyfno">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-vip" aria-hidden="true" data-id="element-52" data-mp="oxetb103wu77" />
                    <span className="text-[14px] text-white/75" data-id="element-53" data-mp="1gmrt0jvt53wx">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col justify-between p-6 sm:p-8 md:col-span-2 md:p-10" data-id="element-54" data-mp="1cjv6ii35cnnp">
              <div data-id="element-55" data-mp="17mbrhfymk6up">
                <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/35 sm:text-[11px]" data-id="element-56" data-mp="17oxvx6q7y68p">
                  Pago único
                </span>
                <p className="mt-3 flex items-baseline gap-2" data-id="element-57" data-mp="3sb980aecjgtf">
                  <span className="text-[34px] font-semibold tracking-tight text-white sm:text-4xl" data-id="element-58" data-mp="3tthpmuksd47u">
                    6.990
                  </span>
                  <span className="font-mono text-[13px] text-white/40" data-id="element-59" data-mp="2mwylauqdwat">
                    CLP
                  </span>
                </p>
              </div>

              <div className="mt-8 md:mt-10" data-id="element-60" data-mp="3otv9oddkp9vc">
                <a href="https://hotmart.com" target="_blank" rel="noopener noreferrer" className="group inline-flex w-full items-center justify-center gap-2 rounded-md bg-cyan-vip px-4 py-3.5 text-center text-[13px] font-semibold leading-tight tracking-tight text-ink shadow-glow transition-[box-shadow,transform,background-color] duration-150 ease-out hover:shadow-glow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-vip focus-visible:ring-offset-2 focus-visible:ring-offset-ink-800 active:translate-y-px sm:px-5 sm:text-[14px]" data-id="element-61" data-mp="3owzijo1zgtsc">
                  Obtener Acceso Inmediato en Hotmart
                  <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-62" data-mp="2djrwgm51xdum" />
                </a>
                <p className="mt-3 text-center font-mono text-[11px] text-white/30" data-id="element-63" data-mp="2igicj9guw9g1">
                  Entrega inmediata · Pago seguro vía Hotmart
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}